import { Link } from '@tanstack/react-router'
import { Modal } from './Modal'
import { Button, Tag } from '@/components/atoms'
import { useLimitsStore } from '@/stores/limits-store'

const KIND_LABELS: Record<string, string> = {
  chat: '채팅',
  upper: '복잡한 작업',
  opus: '어려운 작업',
  db_write: '데이터 저장',
  db_read: '데이터 읽기',
  deploy: '작품 공개',
  tool_call: '외부 데이터 가져오기',
}

/**
 * 429 한도 초과 모달. spec §3.10.
 * 백엔드가 어느 kind에서 막혔는지 detail에 담아 보내면 사용자에게 명확히 표시.
 */
export function LimitExceededModal() {
  const { exceededModal, closeLimitExceeded } = useLimitsStore()
  const { open, message, detail } = exceededModal

  const kindLabel = detail?.kind ? (KIND_LABELS[detail.kind] ?? detail.kind) : null

  return (
    <Modal
      open={open}
      onOpenChange={(o) => {
        if (!o) closeLimitExceeded()
      }}
      size="sm"
      title="오늘 쓸 수 있는 양을 다 썼어요"
      description="자정에 자동으로 다시 채워져요. 그때까지 기다리거나, 플랜을 올려보는 것도 좋아요."
      footer={
        <div className="flex items-center justify-end gap-2 w-full">
          <Button variant="ghost" onClick={closeLimitExceeded}>
            닫기
          </Button>
          <Link
            to="/payment"
            onClick={closeLimitExceeded}
            className="inline-flex items-center justify-center h-10 px-4 rounded-md bg-primary text-white text-sm font-bold hover:bg-primary-hover transition-all"
          >
            플랜 업그레이드 보기
          </Link>
        </div>
      }
    >
      <div className="flex flex-col gap-3">
        {kindLabel && (
          <Tag variant="warn">{kindLabel} 한도 초과</Tag>
        )}
        <p className="text-[14px] text-text leading-relaxed">{message}</p>
        {detail?.used !== undefined && detail.limit !== undefined && (
          <div className="rounded-md bg-surface-alt p-4 text-[13px] text-text-2 font-mono">
            <p>
              사용: <strong className="text-text">{detail.used}</strong> / {detail.limit}
            </p>
            {detail.plan && (
              <p className="mt-1">
                현재 플랜: <strong className="text-text">{detail.plan}</strong>
              </p>
            )}
          </div>
        )}
        <p className="text-[12px] text-text-3">
          매일 자정에 다시 채워져요. 자주 막힌다면 프리미엄을 써봐요. 어려운 작업도 막힘없이 돼요.
        </p>
      </div>
    </Modal>
  )
}
